import {
  ADD_ITEM_TO_STATES_LIST,
  REMOVE_ITEM_FROM_STATES_LIST,
  CLEAR_STATES_LIST,
} from "../types";

export default function appStatesList(state = {}, action = {}) {
  switch (action.type) {
    case ADD_ITEM_TO_STATES_LIST: {
      let appStates = state.appStates;
      if (!appStates) appStates = {};
      appStates[action.stateData.stateKey] = action.stateData.states;
      return { ...state, appStates };
    }
    case REMOVE_ITEM_FROM_STATES_LIST: {
      let appStates = state.appStates;
      if (!appStates) appStates = {};
      if (Object.keys(appStates).includes(action.stateData.stateKey)) {
        delete appStates[action.stateData.stateKey];
      }
      return { ...state, appStates };
    }
    case CLEAR_STATES_LIST: {
      return { ...state, appStates: {} };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appStatesList.js